import { createContext, useReducer } from 'react';

import businessesReducer from './businessReducer';

export const BusinessContext = createContext();

const INITIAL_STATE = {
    businesses: [],
    selectedBusiness: null,
    isApproveModalOpen: false,
    isRejectModalOpen: false,
    reloadBusinesses: 0
};
export const BusinessProvider = ({ children }) => {
    const [state, dispatch] = useReducer(businessesReducer, { ...INITIAL_STATE });

    return (
        <BusinessContext.Provider
            value={{
                dispatch,
                state
            }}>
            {children}
        </BusinessContext.Provider>
    );
};
